import { render, staticRenderFns } from "./Headlines.vue?vue&type=template&id=d261d5b8&scoped=true&"
import script from "./Headlines.vue?vue&type=script&lang=js&"
export * from "./Headlines.vue?vue&type=script&lang=js&"
import style0 from "./Headlines.vue?vue&type=style&index=0&id=d261d5b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d261d5b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VImg,VRow})
